export { default } from './WidgetTrustpilot';
